import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getSavedSimulations, loadSimulation, deleteSimulation } from '../../actions/dataAction';
import styled from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faTrash from '@fortawesome/fontawesome-free-solid/faTrashAlt';

import {
  Table,
  TableBody,
  TableFooter,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';

const styles = {
  propContainer: {
    width: 200,
    overflow: 'hidden',
    margin: '20px auto 0',
  },
  propToggleHeader: {
    margin: '20px auto 10px',
  },
};


const TrashBin = styled(FontAwesomeIcon)`
    margin-left:10px;
`;

/**
 * A more complex example, allowing the table height to be set, and key boolean properties to be toggled.
 */
class TableExampleComplex extends Component {
  state = {
    fixedHeader: true,
    fixedFooter: true,
    stripedRows: false,
    showRowHover: true,
    selectable: true,
    multiSelectable: false,
    enableSelectAll: false,
    deselectOnClickaway: true,
    showCheckboxes: false,
    height: '200px',
  };

  componentDidMount() {
      this.props.getSavedSimulations();
  }

  savedSimulationsList = () => {
    let items = [];
    let simulations = this.props.data.simulations ? this.props.data.simulations:{};
    for (var key in simulations) {
        if (simulations.hasOwnProperty(key)) {
            items.push(simulations[key]);
        }
    }
    return items;
  }

  handleToggle = (event, toggled) => {
    this.setState({
      [event.target.name]: toggled,
    });
  };

  handleChange = (event) => {
    this.setState({height: event.target.value});
  };

  loadSimulation = (index, col) => {
    this.props.loadSimulation(this.savedSimulationsList()[index]);
    this.props.close();
  };

  delete(e, id) {
    e.preventDefault();
    e.stopPropagation();

    if (id) {
      this.props.deleteSimulation(id);
    };

  }

  render() {
    return (
      <div>

        <Table
          height={this.state.height}
          fixedHeader={this.state.fixedHeader}
          fixedFooter={this.state.fixedFooter}
          selectable={this.state.selectable}
          multiSelectable={this.state.multiSelectable}
          onCellClick={this.loadSimulation}
        >
          <TableHeader
            displaySelectAll={this.state.showCheckboxes}
            adjustForCheckbox={this.state.showCheckboxes}
            enableSelectAll={this.state.enableSelectAll}
          >
            <TableRow>
              <TableHeaderColumn tooltip="Name">Name</TableHeaderColumn>
              <TableHeaderColumn tooltip="Date saved">Date saved</TableHeaderColumn>
              <TableHeaderColumn tooltip="" style={{textAlign:'right'}}></TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={this.state.showCheckboxes}
            deselectOnClickaway={this.state.deselectOnClickaway}
            showRowHover={this.state.showRowHover}
            stripedRows={this.state.stripedRows}
          >
            {this.savedSimulationsList().map( (row, index) => (
              <TableRow key={index} className="pointer">
                <TableRowColumn>{row.title}</TableRowColumn>
                <TableRowColumn>{row.createdOn}</TableRowColumn>
                <TableRowColumn key="delete" style={{textAlign:'right'}}><TrashBin icon={faTrash} onClick={(e)=> this.delete(e, row.id)}/></TableRowColumn>
              </TableRow>
              ))}
          </TableBody>

        </Table>
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        data: state.data
    };
}

export default connect(mapStateToProps, { getSavedSimulations, loadSimulation, deleteSimulation })(TableExampleComplex);



// WEBPACK FOOTER //
// ./src/components/dataViews/SavedSimulations.js